import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Typography$1 from '../../basics/Typography/Typography.js';
import StyledContainer from './Container.style.js';

const Container = ({
  children,
  variant,
  headline
}) => /*#__PURE__*/React$1.createElement(StyledContainer, {
  variant: variant
}, headline && /*#__PURE__*/React$1.createElement("div", {
  className: "container__headline"
}, /*#__PURE__*/React$1.createElement(Typography$1, {
  variant: "subline",
  as: "h2"
}, headline)), children);

Container.propTypes = {
  variant: PropTypes$1.oneOf(['inverted', 'default']),
  headline: PropTypes$1.string,
  children: PropTypes$1.node
};
Container.defaultProps = {
  variant: null,
  headline: null,
  children: null
};

export default Container;
